// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__-nCvk","left":"Arrow_left__rdfy7","right":"Arrow_right__M2DdL","wrapper":"Arrow_wrapper__1Gymd"};